const axios = require('axios');
export function adminEventListeners() {
  const overzichtDownloaden = document.getElementById('overzicht-downloaden');
  if (overzichtDownloaden) {
    overzichtDownloaden.addEventListener('click', () => {
      window.open(overzichtDownloaden.dataset.get_data_url);
    })
  }

  const overzichtOpbouwen = document.getElementById('overzicht-opbouwen');
  if (overzichtOpbouwen) {
    overzichtOpbouwen.addEventListener('click', () => {
      axios.get(overzichtOpbouwen.dataset.trigger_url)
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(() => {
          axios.get(overzichtOpbouwen.dataset.processing_url)
            .catch(function (error) {
              // handle error
              console.log(error);
            }).then(() => {
              overzichtDownloaden.disabled = false
            })
        })
    })
  }
}